export function extractPhoneNumberFromSIP(sipString: string) {
  const match = sipString.match(/sip:\+?(\d+)@/);
  return match ? match[1] : '';
}
